function carte_interactive_toggle_panel()
{
    const $panel = document.querySelector('.carte-layout__data-panel');

    if ($panel.classList.contains('carte-layout__data-panel--hidden')) {
        $panel.classList.remove('carte-layout__data-panel--hidden');
    } else {
        $panel.classList.add('carte-layout__data-panel--hidden');
    }

}

let panelToggler = document.getElementsByClassName('.js-toggle-panel');
if(panelToggler[0]){
    panelToggler[0].addEventListener('click',carte_interactive_toggle_panel);
}
//on('body', 'click', '.js-toggle-panel', carte_interactive_toggle_panel);
